import request from '@/utils/request'
import store from '@/store'


const baseUrl = process.env.VUE_APP_BBW_NOTICE_API + '/bbw_notice'
// const baseUrl = 'http://127.0.0.01:8000/bbw_notice'
const bbwPurchaseApi = {
  /*
        page:  //页码
        page_size:  //每页多少条
        search_type:  //搜索类型，1=项目编号，2=项目名称，3=公告名称
        search_key: //搜索关键字
        purchase_model:  //采购类型：1=公开招标,2=邀请招标,3=竞争性磋商,4=竞争性谈判,5=询比价,6=询价
        project_type:  //项目类型：1=工程类,2=货物类,3=服务类
        notice_type:  //公告类型：1=采购公告,2=采购公告变更,3=候选人公示,4=候选人公示变更,5=结果公告,6=结果公告变更,7=澄清公告
        org_type:  //组织形式：1=委托采购,2=自行采购
        subject_name:  //传递机构代码
		region_code: 行政直属
    cods:企业码信息
    */
  list(params) {
    // eslint-disable-next-line no-prototype-builtins
    if(store.getters.site.jsonConfig?.hasOwnProperty('cods')){
      params.cods = store.getters.site.jsonConfig.cods.join(',')
    }
    return request({  
      url: '/list',
      method: 'GET',
      params,
      baseURL: baseUrl,
    })
  },
  // 当前公告下标段所有公告分类数量
  // purchase_project_code 项目编号
  // notice_id 公告ID
  count_by_project(params) {
    return request({
      url: '/count_by_project',
      method: 'GET',
      params,
      baseURL: baseUrl,
    })
  },
  // 获取站点区域单位
  get_enterprises(region_name,cods) {
    return request({
      url: '/get_enterprises',
      method: 'GET',
      params: {
        region_name: region_name,
        cods:cods
      },
      baseURL: baseUrl,
    })
  },
  // 开标项目,时间范围 1=今日，2=昨日，3=本周
  bid_opening_items(times, region_code = '') {
    return request({
      url: '/bid_opening_items',
      method: 'GET',
      params: {
        times: times,
        region_code: region_code,
      },
      baseURL: baseUrl,
    })
  },

  // 获取项目下公告详情
  // purchase_project_code
  // notice_id
  // notice_type
  notice_detail(params) {
    return request({
      url: '/notice_detail',
      method: 'GET',
      params,
      baseURL: baseUrl,
    })
  },
  // 获取公告下标段列表
  get_bid_by_notice(notice_type, notice_id, num = 6) {
    return request({
      url: '/get_bid_by_notice',
      method: 'GET',
      params: {
        notice_type: notice_type,
        notice_id: notice_id,
        num: num,
      },
      baseURL: baseUrl,
    })
  },
  // https://testnewcms.bbwcq.com/bbw_project/downloads/20240803/20240803091137_index.html
  get_test_HTML(url) {
    return request({
      url: url,
      method: 'GET',
      // baseURL: process.env.VUE_APP_BBW_NOTICE_API,
      baseURL:'/bbw_project',
    })
  },
  get_prod_HTML(url) {
    return request({
      url: url,
      method: 'GET',
      // baseURL: process.env.VUE_APP_BBW_NOTICE_API,
      baseURL:'/bbw_prod',
    })
  },
  // 通用请求
  get_requset(url) {
    return request({
      url: url,
      method: 'GET',
    })
  },
}
export default bbwPurchaseApi
